import { createRootStore } from 'libx';

import TnvedTreeStore from 'stores/TnvedTreeStore';
import GngTreeStore from 'stores/GngTreeStore';
import EtsngTreeStore from 'stores/EtsngTreeStore';
import AppStore from 'stores/AppStore';
import QueryParamsStore from 'stores/QueryParamsStore';
import CountryStore from 'stores/CountryStore';

const rootStore = createRootStore({
  queryParamsStore: QueryParamsStore,
  appStore: AppStore,
  tnvedTreeStore: TnvedTreeStore,
  gngTreeStore: GngTreeStore,
  etsngTreeStore: EtsngTreeStore,
  countryStore: CountryStore
});

export default rootStore;



// WEBPACK FOOTER //
// ./src/stores/RootStore.js